import React from "react";

const ConnectedAccIcon = ({
  fill = "#387CFF",
  stroke = "#387CFF",
  ...props
}) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props} // Spread additional props (e.g., className, style)
  >
    <path
      d="M2.4 3.8C2.7713 3.8 3.1274 3.6525 3.38995 3.38995C3.6525 3.1274 3.8 2.7713 3.8 2.4C3.8 2.0287 3.6525 1.6726 3.38995 1.41005C3.1274 1.1475 2.7713 1 2.4 1C2.0287 1 1.6726 1.1475 1.41005 1.41005C1.1475 1.6726 1 2.0287 1 2.4C1 2.7713 1.1475 3.1274 1.41005 3.38995C1.6726 3.6525 2.0287 3.8 2.4 3.8ZM3.1 14.3C3.65695 14.3 4.1911 14.0788 4.58492 13.6849C4.97875 13.2911 5.2 12.757 5.2 12.2C5.2 11.643 4.97875 11.1089 4.58492 10.7151C4.1911 10.3212 3.65695 10.1 3.1 10.1C2.54305 10.1 2.0089 10.3212 1.61508 10.7151C1.22125 11.1089 1 11.643 1 12.2C1 12.757 1.22125 13.2911 1.61508 13.6849C2.0089 14.0788 2.54305 14.3 3.1 14.3ZM12.9 15C13.457 15 13.9911 14.7788 14.3849 14.3849C14.7788 13.9911 15 13.457 15 12.9C15 12.343 14.7788 11.8089 14.3849 11.4151C13.9911 11.0212 13.457 10.8 12.9 10.8C12.343 10.8 11.8089 11.0212 11.4151 11.4151C11.0212 11.8089 10.8 12.343 10.8 12.9C10.8 13.457 11.0212 13.9911 11.4151 14.3849C11.8089 14.7788 12.343 15 12.9 15ZM7.3 9.4C8.04261 9.4 8.7548 9.105 9.2799 8.5799C9.805 8.0548 10.1 7.34261 10.1 6.6C10.1 5.85739 9.805 5.1452 9.2799 4.6201C8.7548 4.095 8.04261 3.8 7.3 3.8C6.55739 3.8 5.8452 4.095 5.3201 4.6201C4.795 5.1452 4.5 5.85739 4.5 6.6C4.5 7.34261 4.795 8.0548 5.3201 8.5799C5.8452 9.105 6.55739 9.4 7.3 9.4ZM11.5 3.8C11.8713 3.8 12.2274 3.6525 12.4899 3.38995C12.7525 3.1274 12.9 2.7713 12.9 2.4C12.9 2.0287 12.7525 1.6726 12.4899 1.41005C12.2274 1.1475 11.8713 1 11.5 1C11.1287 1 10.7726 1.1475 10.5101 1.41005C10.2475 1.6726 10.1 2.0287 10.1 2.4C10.1 2.7713 10.2475 3.1274 10.5101 3.38995C10.7726 3.6525 11.1287 3.8 11.5 3.8Z"
      stroke={fill}
      strokeWidth="1.13"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.44922 3.45001L4.84922 4.85001M10.0992 3.80001L9.39922 4.50001M11.4992 11.325L9.39922 8.70001M4.49922 10.45L5.89922 9.05001"
      stroke={fill}
      strokeWidth="1.13"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ConnectedAccIcon;
